"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataObjectBuilder = void 0;
var realmforge_common_1 = require("realmforge-common");
var AmbientLightDataObjectBuilder_1 = require("./AmbientLightDataObjectBuilder");
var BlueprintRefDataObjectBuilder_1 = require("./BlueprintRefDataObjectBuilder");
var BoxDataObjectBuilder_1 = require("./BoxDataObjectBuilder");
var CylinderDataObjectBuilder_1 = require("./CylinderDataObjectBuilder");
var DirectionalLightDataObjectBuilder_1 = require("./DirectionalLightDataObjectBuilder");
var GroupDataObjectBuilder_1 = require("./GroupDataObjectBuilder");
var HemisphereLightDataObjectBuilder_1 = require("./HemisphereLightDataObjectBuilder");
var PluginDataObjectBuilder_1 = require("./PluginDataObjectBuilder");
var SphereDataObjectBuilder_1 = require("./SphereDataObjectBuilder");
var SpriteDataObjectBuilder_1 = require("./SpriteDataObjectBuilder");
var PlaneDataObjectBuilder_1 = require("./PlaneDataObjectBuilder");
var Asset3DDataObjectBuilder_1 = require("./Asset3DDataObjectBuilder");
/*
 * Builds a data object
 */
var DataObjectBuilder = /** @class */ (function () {
    function DataObjectBuilder(builders) {
        var _a;
        if (builders === void 0) { builders = {}; }
        var _this = this;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        // Maps type to builder
        this.dataObjectBuilderMapping = (_a = {},
            _a[realmforge_common_1.DataObjectType.Box] = (_b = builders[realmforge_common_1.DataObjectType.Box]) !== null && _b !== void 0 ? _b : new BoxDataObjectBuilder_1.BoxDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.Group] = (_c = builders[realmforge_common_1.DataObjectType.Group]) !== null && _c !== void 0 ? _c : new GroupDataObjectBuilder_1.GroupDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.Sphere] = (_d = builders[realmforge_common_1.DataObjectType.Sphere]) !== null && _d !== void 0 ? _d : new SphereDataObjectBuilder_1.SphereDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.Plane] = (_e = builders[realmforge_common_1.DataObjectType.Plane]) !== null && _e !== void 0 ? _e : new PlaneDataObjectBuilder_1.PlaneDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.Cylinder] = (_f = builders[realmforge_common_1.DataObjectType.Cylinder]) !== null && _f !== void 0 ? _f : new CylinderDataObjectBuilder_1.CylinderDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.BlueprintRef] = (_g = builders[realmforge_common_1.DataObjectType.BlueprintRef]) !== null && _g !== void 0 ? _g : new BlueprintRefDataObjectBuilder_1.BlueprintRefDataObjectBuilder(function (dataObject, allDataObjects, methods) {
                return _this.buildThreeObject(dataObject, allDataObjects, methods);
            }),
            _a[realmforge_common_1.DataObjectType.HemisphereLight] = (_h = builders[realmforge_common_1.DataObjectType.HemisphereLight]) !== null && _h !== void 0 ? _h : new HemisphereLightDataObjectBuilder_1.HemisphereLightDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.AmbientLight] = (_j = builders[realmforge_common_1.DataObjectType.AmbientLight]) !== null && _j !== void 0 ? _j : new AmbientLightDataObjectBuilder_1.AmbientLightDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.DirectionalLight] = (_k = builders[realmforge_common_1.DataObjectType.DirectionalLight]) !== null && _k !== void 0 ? _k : new DirectionalLightDataObjectBuilder_1.DirectionalLightDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.PluginDataObject] = (_l = builders[realmforge_common_1.DataObjectType.PluginDataObject]) !== null && _l !== void 0 ? _l : new PluginDataObjectBuilder_1.PluginDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.Sprite] = (_m = builders[realmforge_common_1.DataObjectType.Sprite]) !== null && _m !== void 0 ? _m : new SpriteDataObjectBuilder_1.SpriteDataObjectBuilder(),
            _a[realmforge_common_1.DataObjectType.Asset3D] = (_o = builders[realmforge_common_1.DataObjectType.Asset3D]) !== null && _o !== void 0 ? _o : new Asset3DDataObjectBuilder_1.Asset3DDataObjectBuilder(),
            _a);
    }
    DataObjectBuilder.prototype.getBuilder = function (type) {
        return this.dataObjectBuilderMapping[type];
    };
    /*
     * Creates the data object
     */
    DataObjectBuilder.prototype.createDataObject = function (params) {
        return this.dataObjectBuilderMapping[params.type].createDataObject(params);
    };
    /*
     * Creates the three object
     */
    DataObjectBuilder.prototype.buildThreeObject = function (dataObject, allDataObjects, methods) {
        return this.dataObjectBuilderMapping[dataObject.type].buildThreeObject(dataObject, allDataObjects, methods);
    };
    /*
     * Updates data object
     */
    DataObjectBuilder.prototype.updateDataObject = function (oldDataObject, params) {
        return this.dataObjectBuilderMapping[oldDataObject.type].updateDataObject(oldDataObject, params);
    };
    /*
     * Updates three object
     */
    DataObjectBuilder.prototype.updateThreeObject = function (params, threeObject, methods) {
        return this.dataObjectBuilderMapping[params.type].updateThreeObject(params, threeObject, methods);
    };
    return DataObjectBuilder;
}());
exports.DataObjectBuilder = DataObjectBuilder;
